import RNCouchbaseLite from "./internal/nativeInterface";

export const getMessageFromNativeModule = () => {
  return RNCouchbaseLite.getMessageFromNativeModule();
};

export const createDatabase = (databaseName: string) => {
  return RNCouchbaseLite.createDatabase(databaseName);
};

export const saveDocument = (document: Document) => {
  const {key, value } = document
  return RNCouchbaseLite.saveDocument(key, value);
};

export const fetchDocuments = (property: string, value: string) => {
  return RNCouchbaseLite.fetchDocuments(property, value);
};

export default {
  getMessageFromNativeModule,
  createDatabase,
  saveDocument,
  fetchDocuments
}
